package com.yet.tetris.database

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.yet.tetris.database.database.newInstance
import com.yet.tetris.database.database.schema
import kotlin.Unit

public interface TetrisLiteDatabase : SuspendingTransacter {
  public val boardCellsQueries: BoardCellsQueries

  public val currentGameStateQueries: CurrentGameStateQueries

  public val gameHistoryQueries: GameHistoryQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = TetrisLiteDatabase::class.schema

    public operator fun invoke(
      driver: SqlDriver,
      BoardCellsAdapter: BoardCells.Adapter,
      CurrentGameStateAdapter: CurrentGameState.Adapter,
      GameHistoryAdapter: GameHistory.Adapter,
    ): TetrisLiteDatabase = TetrisLiteDatabase::class.newInstance(driver, BoardCellsAdapter, CurrentGameStateAdapter, GameHistoryAdapter)
  }
}
